import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'dcsgStripSpecialChars'
})

export class StripSpecialCharsPipe implements PipeTransform {
	public transform(value, pattern?: string): any {
		// if value is undefined return empty string
		if (typeof value === 'undefined') {
			return '';
		}

		if (typeof pattern !== 'undefined') {
			return value.replace(new RegExp(pattern, 'gi'), '');
		}

		// eslint-disable-next-line no-useless-escape
		return value.replace(/\s|\!|\@|\#|\$|\%|\^|\*|\(|\)|\{|\}|\[|\]|\;|\'|\"|\,|<|>|\.|\/|\\|\||\?|\_|\+|\=|\`|\~|\‘|\’|\“|\”|\…|\′/g, '');
	}
}